require('./toolbar.js');

Pegasus.ImageToolbarController = Pegasus.ToolbarController.extend({
  needs: ['toolbar'],
  content: function(){
    return this.get('controllers.toolbar.content');
  }.property('controllers.toolbar.content'),
  hasErrors: function(){
    if(!Ember.isEmpty(this.get('content.errors.dataName')) ||
      !Ember.isEmpty(this.get('content.errors.dataAlt')) ){
      return true;
    }
    return false;
  }.property('content.errors.@each', 'errors.@each').volatile()
});
